import { axiosClient, config } from "./Config";
// var apiConfig = require('../Services/constant.json')[process.env.REACT_APP_ENV || 'dev'];
const { REACT_APP_ENV } = process.env;
var apiConfig = require("../Services/constant.json")[REACT_APP_ENV.trim()];

export const api = {
  getBaseUrl() {
    return apiConfig.base_url;
  },
  getMarketData(userId) {
    return axiosClient
      .get(apiConfig.base_url + "/admin/reports/markets", {})
      .then((responseJson) => {
        return responseJson.data;
        // return JSON.stringify(responseJson.data.data);
      })
      .catch((error) => {
        return error;
      });
  },

  getStoreData(marketId) {
    return axiosClient
      .get(
        apiConfig.base_url + "/admin/reports/stores" + "?marketid=" + marketId,
        {},
      )
      .then((responseJson) => {
        return responseJson.data;
      })
      .catch((error) => {
        return error;
      });
  },

  getAssociateData(marketId, storeId) {
    try {
      return axiosClient
        .get(
          apiConfig.base_url +
            "/admin/reports/associates" +
            "?marketid=" +
            marketId +
            "&storeid=" +
            storeId,
          {},
        )
        .then((responseJson) => {
          return responseJson.data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  },

  getDailySummaryData(marketId, storeId, associateId, startDate, endDate) {
    try {
      // return axiosClient
      // .get(apiConfig.base_url + '/admin/reports/dailysummaryreports'+
      //  	  '?marketid=' +
      //  	  marketId+
      // 	   '&storeid=' +
      // 	   storeId+
      // 	   '&associateid=' +
      // 	   associateId+
      // 	   '&startdate=' +
      // 	   startDate+
      // 	   '&enddate=' +
      // 	   endDate, {
      // })
      return axiosClient
        .get(apiConfig.base_url + "/admin/reports/dailysummaryreports", {})
        .then((responseJson) => {
          return responseJson.data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  },

  getAssociateComparisonData(marketId, storeId, startDate, endDate) {
    try {
      return axiosClient
        .get(apiConfig.base_url + "/admin/reports/associatereports", {})
        .then((responseJson) => {
          return responseJson.data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  },

  getStoreComparisonData(marketId, startDate, endDate) {
    try {
      return axiosClient
        .get(apiConfig.base_url + "/admin/reports/storereports", {})
        .then((responseJson) => {
          return responseJson.data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  },

  getMarketComparisonData(action) {
    // console.log('action');
    // console.log(action);
    const { startDate, endDate } = action;
    try {
      return axiosClient
        .get(
          apiConfig.base_url +
            "/admin/reports/marketreports" +
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate,
          {},
        )
        .then((responseJson) => {
          return responseJson.data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  },

  getDailySummaryDataPost(action) {
    const { startDate, endDate, salesrepid, storeId, timezone } = action;
    return axiosClient
      .post(apiConfig.base_url + "/admin/reports/dailysummaryreports", {
        startDate: startDate,
        endDate: endDate,
        salesrepid: salesrepid,
        storeId: storeId,
        timezone: timezone,
      })
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  getAssociateComparisonDataPost(action) {
    // console.log('action');
    // console.log(action);
    const { startDate, endDate, salesrepid, storeId } = action;
    return axiosClient
      .post(apiConfig.base_url + "/admin/reports/associatereports", {
        startDate: startDate,
        endDate: endDate,
        salesrepid: salesrepid,
        storeId: storeId,
      })
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  getStoreComparisonDataPost(action) {
    const { startDate, endDate, salesrepid, marketId } = action;
    return axiosClient
      .post(apiConfig.base_url + "/admin/reports/storereports", {
        startDate: startDate,
        endDate: endDate,
        salesrepid: salesrepid,
        marketId: marketId,
      })
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  getDCGQUestionTemplate() {
    try {
      return axiosClient
        .get(apiConfig.base_url + "/admin/base-template", {
          // .get(apiConfig.base_url + '/UAT/admin/base-template', {
          // .get(apiConfig.base_url + '/v1/admin/template/1', {
        })
        .then((responseJson) => {
          return responseJson.data.data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  },

  publishDCGQuestion(action) {
    const { templateid, loginname, userloginid, sections } = action;
    console.log("action");
    console.log(action);
    return axiosClient
      .post(apiConfig.base_url + "/admin/template/publish", {
        templateid: templateid,
        loginname: loginname,
        userloginid: userloginid,
        sections: sections,
      })
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  ////faq
  getFaqData(userId) {
    try {
      return axiosClient
        .get(
          apiConfig.base_url +
            "/admin/faq/retrievefaqs" +
            "?salesrepname=" +
            userId,
          {},
        )
        .then((responseJson) => {
          return responseJson.data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  },

  publishFAQ(action) {
    const { salesrepname, faqs } = action;
    console.log("action");
    console.log(action);
    return axiosClient
      .post(apiConfig.base_url + "/admin/faq/publishfaqs", {
        salesrepname: salesrepname,
        faqs: faqs,
      })
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  getIndFaqData(faqId) {
    try {
      return axiosClient
        .get(
          apiConfig.base_url +
            "/admin/faq/retrievefaqsbyid" +
            "?faqid=" +
            faqId,
          {},
        )
        .then((responseJson) => {
          return responseJson.data;
        })
        .catch((error) => {
          return error;
        });
    } catch (error) {
      return error;
    }
  },

  // faq end
  getemailSummaryDataPost(action) {
    return axiosClient
      .post(
        apiConfig.base_url + "/admin/reports/customeremailviewreports",
        action,
      )
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  getStatusReportDataPost(action) {
    return axiosClient
      .post(apiConfig.base_url + "/admin/reports/dcgstatusreports", action)
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  getDesignerAppointmentReportsDataPost(action) {
    return axiosClient
      .post(
        apiConfig.base_url + "/admin/reports/dcgdesignerappointmentreports",
        action,
      )
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  getStatusesDataPost() {
    return axiosClient
      .get(apiConfig.base_url + "/admin/reports/statuses")
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        return error;
      });
  },

  getAllStoresData() {
    return axiosClient
      .get(apiConfig.base_url + "/admin/reports/allstores")
      .then((responseJson) => {
        return responseJson.data;
      })
      .catch((error) => {
        return error;
      });
  },

  createdcgstatus(obj) {
    return axiosClient
      .post(apiConfig.base_url + "/dcgforms/dcgstatus/createdcgstatus", obj)
      .then((result) => {
        return result.data;
      })
      .catch((error) => {
        return error;
      });
  },
  deleteDcg(obj) {
    return axiosClient
      .post(apiConfig.base_url + "/admin/deletedcgwithdcgid", obj)
      .then((result) => {
        return result.data;
      })
      .catch((error) => {
        return error;
      });
  },
  getAllAttachments(dcgid) {
    return axiosClient
      .get(
        apiConfig.base_url +
          `/dcgforms/attachments/getallattachments?dcgid=${dcgid}`,
      )
      .then((result) => {
        return result.data;
      })
      .catch((error) => {
        return error;
      });
  },

  getNotes(dcgid) {
    return axiosClient
      .get(
        apiConfig.base_url +
          `/dcgforms/hiddennote/retrievehiddennote?dcgid=${dcgid}`,
      )
      .then((result) => {
        return result.data;
      })
      .catch((error) => {
        return error;
      });
  },
};
